<template>
  <modal
    :show.sync="isActiveLocal"
    size="lg"
    centered
    header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
    modal-content-classes=""
    hide-footer
    class="overflow-y-hidden"
  >
    <div class="flex justify-between">
      <div class="flex">
        <div class="mx-8 mt-8">
          <div class="flex justify-between items-center pb-6">
            <p class="font-bold text-2xl text-black">
              {{ selectedService.name }}
            </p>
            <img
              src="../../../assets/images/cross.png"
              class="h-8 w-8 cursor-pointer"
              alt="cross"
              @click="isActiveLocal = false"
            />
          </div>
          <div v-html="selectedService.html"></div>
        </div>
      </div>
    </div>

    <template slot="footer"> <div></div> </template>
  </modal>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedService: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
li {
  padding-top: 5px;
  list-style: disc;
  /* color: black; */
}
</style>
